import styled from 'styled-components'

export const TextAreaWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: start;
	width: 90%;
	margin: 20px;
`
